import { UserType } from '@creative-suite/react-components';
import { storageHelper } from '@spo/logic';
import { Env, environment } from '../environments/environment';
import { Medallia } from '../utils/medallia';

// The beforeSigninUrl is used in the AuthenticationPage component but its life cycle is handled here to avoid calling the token endpoint more than once
const BEFORE_SIGNIN_URL = 'before_signin_url';

export const useAuthProvider = (): boolean => {
  const isAuthenticated = (): boolean =>
    storageHelper.getItem<boolean>('is_authenticated') === true;

  const onBeforeSignIn = (path: string) => {
    storageHelper.setItem(BEFORE_SIGNIN_URL, path);
  };

  const onSignIn = (user: UserType | null) => {
    const storedPath = storageHelper.getItem(BEFORE_SIGNIN_URL);
    if (storedPath) {
      storageHelper.removeItem(BEFORE_SIGNIN_URL);
    }
    if (user) {
      Medallia.setCustomParams({
        storeId: user.site,
        countryCode: user.c,
        jobName: user.jobname,
        languageCode: user.preferredLanguage,
        uid: user.uid,
        env: environment.env as Env,
      });
    }
  };

  const user = storageHelper.getItem<UserType>('user');

  if (isAuthenticated() && user) {
    onSignIn(user);
  } else {
    const currentUrl = window.location.pathname;
    if (!currentUrl.includes('authentication')) {
      const fullPath = window.location.pathname + window.location.search;
      onBeforeSignIn(fullPath);
    }
  }

  return isAuthenticated();
};
